import { EstimateRow } from "features/subscriptions/components/ManageSubscription/EstimateRow";
import { PRICING_PLANS } from "features/subscriptions/constants";
import {
  formatPrice,
  formatPricingPeriodInfo,
} from "features/subscriptions/utils";

import type { PricingPeriodInfo, SubscriptionType } from "common/types";

export default function NewPrice({
  subscriptionType,
  price,
  pricingPeriodInfo,
  isLoading,
}: {
  subscriptionType: SubscriptionType;
  price: number;
  pricingPeriodInfo: PricingPeriodInfo;
  isLoading: boolean;
}) {
  return (
    <EstimateRow
      label="New price"
      tooltipText={PRICING_PLANS[subscriptionType].tooltipText.newPrice}
      value={
        price
          ? `${formatPrice(price)} / ${formatPricingPeriodInfo(pricingPeriodInfo)}`
          : "-"
      }
      valueClassName="text-md-bold"
      isLoading={isLoading}
    />
  );
}
